import React from 'react';
import { Link } from 'react-router-dom';
import './Events.css';

const Events = ({ data }) => {
    // Parse date string to Date object for sorting
    const parseEventDate = (dateStr) => {
        // Handle "Date TBA" or similar formats
        if (!dateStr || dateStr.includes('TBA')) {
            return new Date(9999, 11, 31); // Future date for TBA events
        }

        // Try to parse the date string
        const parsed = new Date(dateStr);
        if (!isNaN(parsed.getTime())) {
            return parsed;
        }

        // Fallback to current date if parsing fails
        return new Date();
    };

    // Sort events by date in descending order (newest first)
    const sortedEvents = [...data.items].sort((a, b) => {
        return parseEventDate(b.date) - parseEventDate(a.date);
    });

    // Show only the 3 most recent events on homepage
    const recentEvents = sortedEvents.slice(0, 3);

    return (
        <section className="events section" id={data.id}>
            <div className="container">
                <div className="section-title">
                    <h2>{data.title}</h2>
                </div>
                <p className="section-intro">{data.intro}</p>

                <div className="events-grid">
                    {recentEvents.map((event, index) => (
                        <Link
                            key={event.slug}
                            to={`/events/${event.slug}`}
                            className={`event-card ${event.status === 'past' ? 'past-event' : ''}`}
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <div className="event-image">
                                <img src={event.image} alt={event.imageAlt} />
                                <div className="event-status-badge">
                                    {event.status === 'upcoming' ? (
                                        <span className="upcoming">Upcoming</span>
                                    ) : (
                                        <span className="past">Past Event</span>
                                    )}
                                </div>
                            </div>
                            <div className="event-content">
                                <h3>{event.title}</h3>
                                <div className="event-details">
                                    <div className="event-detail">
                                        <i className="fas fa-calendar"></i>
                                        <span>{event.date}</span>
                                    </div>
                                    <div className="event-detail">
                                        <i className="fas fa-map-marker-alt"></i>
                                        <span>{event.location}</span>
                                    </div>
                                </div>
                                <p>{event.summary}</p>
                            </div>
                        </Link>
                    ))}
                </div>

                <div className="text-center" style={{ marginTop: '40px' }}>
                    <Link to="/events" className="btn btn-primary">
                        <i className="fas fa-calendar-alt"></i> View All Events
                    </Link>
                </div>
            </div>
        </section>
    );
};

export default Events;
